import { Dialog, Switch, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/solid';
import React, { Fragment, useEffect, useState } from 'react';
import { formatDate, numberFormatWithoutSymbol, showToast } from '../../../Utils';
import { bookVenueByAdmin, getVenuePackages } from '../../../api/VenueInteractor';
import NumberWithButtons from '../../NumberWithButtons';
import { deleteAddOn, getAddOnList } from '../../../api/AddOnInteractor';

function BookingConfirmationDialog(props) {
  const inputClass = "w-full text-xs bg-gray-100 rounded-lg py-2.5 px-6 focus:outline-none focus:border focus:border-primaryRed focus:ring-1 focus:ring-primaryRed"

  let [contactName, setContactName] = useState("")
  let [contactNumber, setContactNumber] = useState("")
  let [contactEmail, setContactEmail] = useState("")
  let [specialPrice, setSpecialPrice] = useState(false)
  let [specialPriceAmount, setSpecialPriceAmount] = useState(0)
  let [totalPrice, setTotalPrice] = useState(0)
  let [totalPromoPrice, setTotalPromoPrice] = useState(0)
  const [addons, setAddons] = useState([]);

  let selected_date = new Date(props.venueDetail.dateAvailable);
  let subtotal = 0;
  let totalSchedule = 0;
  let totalAddon = 0;
  let discount = 0;
  let service_fee = props.venueDetail.serviceFee ? props.venueDetail.serviceFee : 0;
  let total = 0;

  props.selectedSchedule.map((schedule) => {
    let promo_period = new Date(schedule.promo_period);
    totalSchedule += schedule.price;
    if (selected_date <= promo_period) {
      discount += schedule.price - schedule.promo_price;
    }
  });
  addons.map((addon) => {
    const isHaveSchedule = addon.add_on_item_schedules.length > 0;
    const hasMatchingSchedule = addon.add_on_item_schedules.filter(schedule =>
      schedule.date_available === props.venueDetail.dateAvailable
    );
    const scheduleHours = hasMatchingSchedule.map(schedule => `${schedule.start_time} - ${schedule.end_time}`);
    const selectedSchedule = props.selectedSchedule.map(schedule => `${schedule.hour}`)
    const isAvailable = selectedSchedule.length > 0 && selectedSchedule.every(item => scheduleHours.includes(item));
    if (!isHaveSchedule || isAvailable) {
      totalAddon += (addon.price * addon.qty);
    } else {
      addon.qty = 0;
    }
  });

  subtotal = totalSchedule + totalAddon;
  total = subtotal - discount + service_fee;



  useEffect(() => {
    // getPackages()
    getAddOnList(
      //success
      (responseJSON) => {
        setAddons(responseJSON)
      },
      //failed
      (message) => {
        showToast("Error", "Create Failed", message)
      }
    )
  }, []);

  const updatePrice = () => {
    let tmpTotalPrice = 0;
    tmpTotalPrice = tmpTotalPrice + (props.selectedSchedule.length)
    addons.forEach(item => {
      tmpTotalPrice = tmpTotalPrice + (item.qty * item.price)
    });
    setTotalPrice(tmpTotalPrice)
  }

  const updatePromoPrice = () => {
    let tmpTotalPrice = 0;
    tmpTotalPrice = tmpTotalPrice + (props.selectedSchedule.length)
    addons.forEach(item => {
      tmpTotalPrice = tmpTotalPrice + (item.qty * item.price)
    });
    setTotalPromoPrice(tmpTotalPrice)
  }

  const updateAddon = (addon, qty) => {
    const tmp = [...addons];
    // if (qty >= 0) {
    tmp.find(item => item.id === addon.id).qty = qty;
    // }
    setAddons(tmp);
  }



  const validateBooking = () => {
    if (contactName == "") {
      return {
        isValid: false,
        validationMessage: "Please input contact name"
      }
    }

    if (contactNumber == "") {
      return {
        isValid: false,
        validationMessage: "Please input contact number"
      }
    }
    let regex = new RegExp(/^[a-zA-Z0-9.!#$%&' * +/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/);


    if ((contactEmail == "") || (!regex.test(contactEmail))) {
      return {
        isValid: false,
        validationMessage: "Please input correct email address"
      }
    }

    if ((specialPrice) && ((specialPriceAmount == 0) || (specialPriceAmount == ""))) {
      return {
        isValid: false,
        validationMessage: "Please input special price"
      }
    }

    return {
      isValid: true,
      validationMessage: ""
    }
  }

  const prepareBooking = () => {

    const validateResult = validateBooking()

    if (validateResult.isValid) {

      let price = 0

      let schedule = []
      // props.selectedSchedule.forEach(item => {
      //   schedule.push({
      //     "service_id": props.venueId.venueId,
      //     "service_date": props.venueDetail.dateAvailable,
      //     "start_time": item.start_time,
      //     "end_time": item.end_time
      //   })
      // });

      props.selectedSchedule.map(time => {
        schedule.push(
          {
            service_id: props.venueId.venueId,
            service_time_id: time.service_time_id,
            service_date: props.venueDetail.dateAvailable,
            start_time: time.hour.split(" - ")[0],
            end_time: time.hour.split(" - ")[1],
            price: time.price,
          }
        );
      });

      let selectedAddons = []
      addons.forEach(addon => {
        if (addon.qty > 0) {
          selectedAddons.push({
            add_on_item_id: addon.id,
            price: addon.price,
            qty: addon.qty,
            total: (addon.price * addon.qty)
          });
        }
      });

      const param = {
        "service_member_book": {
          "service_id": props.venueId.venueId,
          "member_id": 0,
          "service_date": props.venueDetail.dateAvailable,
          "contact_name": contactName,
          "contact_phone": contactNumber,
          "contact_email": contactEmail,
          "total_payment": total,
          "total_dp": 0,
          "booking_times_attributes": schedule,
          "add_on_item_service_member_books_attributes": selectedAddons,
          "transaction_services_attributes":
            [
              {
                "community_id": 0,
                "payment_with": "",
                "pg_code": 0,
                "pg_name": "PAYMENT ADMIN",
                "package_unit": "",
                "qty": 1,
                "package_price": 0,
                "discount": discount,
                "service_fee": service_fee,
                "admin_fee": 0,
                "total": total + discount - service_fee,
                "is_dp": 0
              }
            ]
        }
      }

      console.log("eee ", param)


      bookVenueByAdmin(param,
        //success
        (responseJSON) => {
          showToast("Success", "Booking Success")
          setContactName("")
          setContactNumber("")
          setContactEmail("")
          props.onBookingSucceed()
        },
        //failed
        (message) => {
          showToast("Error", "Booking Failed", message)

        }
      )

    } else {
      showToast("Error", "Failed", validateResult.validationMessage)
    }
  }

  return (
    <>
      <div className="flex items-center justify-center">
        {/* <button onClick={openModal} className='px-12 py-3 text-sm text-white font-[600] bg-primaryRed rounded-lg'>
          Booking Jadwal
        </button> */}
      </div>

      <Transition appear show={props.open} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={props.closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="max-w-4xl w-full z-50 transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-[22px] mb-[30px] font-bold  text-gray-900"
                  >
                    Konfirmasi Booking Jadwal

                  </Dialog.Title>
                  <div className="mt-2 flex flex-col gap-y-4 font-nunito">
                    <p className="text-sm text-gray-500">
                      Anda akan melakukan booking jadwal pada :
                    </p>

                    <div className='flex gap-4'>
                      <div className='w-7/12'>
                        <p className='font-semibold text-gray-700 mb-4 mt-2 text-sm'>Detail Pemesanan</p>

                        <div className='px-6 py-6 flex flex-col gap-y-8 border border-gray-300 rounded-xl mb-4 md:mb-0'>

                          <div className="flex gap-x-4 flex-grow">
                            <div className='gap-y-3 flex flex-col'>
                              <p className='text-sm font-bold'>Nama Venue</p>
                              {/* <p className='text-sm font-semibold text-gray-800'>{data.venue.name}</p> */}
                            </div>
                            <div className="flex-grow" />
                            <div className='gap-y-3 flex flex-col mt-0'>
                              <p className='text-sm font-bold'>Tanggal Booking</p>
                              <p className='text-sm font-semibold text-gray-800'>
                                {formatDate(props.venueDetail.dateAvailable)}
                              </p>
                            </div>

                          </div>
                          <div className="flex gap-x-4 flex-grow">
                            <div className='w-1/2 flex flex-col justify-start'>
                              <p className="text-sm font-bold text-gray-800">TOTAL BAYAR</p>
                              <p className="text-xs text-gray-800">Belum termasuk biaya admin</p>
                            </div>
                            <div className='w-1/2 flex justify-end'>
                              <p className="text-lg font-bold text-gray-800">Rp.&nbsp;</p>
                              <p className="text-lg font-bold text-gray-800">{numberFormatWithoutSymbol(total, false)}</p>
                            </div>
                          </div>
                          <hr />

                          <div className='gap-y-3 flex flex-col flex-grow'>
                            <p className='text-sm font-bold'>Jam Booking</p>
                            {
                              props.selectedSchedule.map((item, index) => (

                                <div key={index} className="flex gap-x-4 flex-grow">
                                  <div className='w-1/2 flex justify-start'>
                                    <p className="text-sm font-bold text-gray-800">{item.hour}</p>
                                  </div>
                                  <div className='w-1/2 flex justify-end flex-col'>
                                    {
                                      <div className='flex justify-end'>
                                        <p className="text-sm font-bold text-gray-800">Rp.&nbsp;</p>
                                        <p className="text-sm font-semibold text-gray-800">{numberFormatWithoutSymbol(item.price, false)}</p>
                                      </div>
                                    }

                                  </div>
                                </div>
                              ))
                            }
                          </div>



                          {addons.filter(item => item.qty > 0).length > 0 && (<>
                            <div className='gap-y-3 flex flex-col flex-grow'>
                              <p className='text-sm font-bold text-gray-500'>Tambahan Add On</p>
                              {
                                addons.filter(item => item.qty > 0).map((item, index) => (
                                  <div key={index} className="flex gap-x-4 flex-grow">
                                    <div className='w-1/2 flex justify-start'>
                                      <p className="text-sm font-bold text-gray-800">{item.name} {item.qty} {item.unit !== "Hour" ? item.unit : `x ${props.selectedSchedule.length} ${item.unit} `}</p>
                                    </div>
                                    <div className='w-1/2 flex justify-end'>
                                      <p className="text-sm font-bold text-gray-800">Rp.&nbsp;</p>
                                      {/* <div className="flex-grow" /> */}
                                      <p className="text-sm font-bold text-gray-800">{numberFormatWithoutSymbol(item.unit !== "Hour" ? item.qty * item.price : item.qty * item.price * props.selectedSchedule.length, false)}</p>
                                    </div>
                                  </div>
                                ))
                              }
                            </div>
                          </>)}

                          <hr />
                          <div className='gap-y-3 flex flex-col flex-grow'>
                            <div className="flex gap-x-4 flex-grow">
                              <div className='w-1/2 flex justify-end'>
                                <p className="text-sm font-bold text-gray-800">SUBTOTAL</p>
                              </div>
                              <div className='w-1/2 flex justify-end'>
                                <p className="text-sm font-bold text-gray-800">Rp.&nbsp;</p>
                                {/* <div className="flex-grow" /> */}
                                <p className="text-sm font-bold text-gray-800">{numberFormatWithoutSymbol(subtotal, false)}</p>
                              </div>
                            </div>
                            <div className="flex gap-x-4 flex-grow">
                              <div className='w-1/2 flex justify-end'>
                                <p className="text-sm font-bold text-gray-800">DISKON LAPANG</p>
                              </div>
                              <div className='w-1/2 flex justify-end'>
                                <p className="text-sm font-bold text-gray-800">- Rp.&nbsp;</p>
                                {/* <div className="flex-grow" /> */}
                                <p className="text-sm font-bold text-gray-800">{numberFormatWithoutSymbol(discount, false)}</p>
                              </div>
                            </div>
                            <div className="flex gap-x-4 flex-grow">
                              <div className='w-1/2 flex justify-end'>
                                <p className="text-sm font-bold text-gray-800">BIAYA LAYANAN</p>
                              </div>
                              <div className='w-1/2 flex justify-end'>
                                <p className="text-sm font-bold text-gray-800">Rp. {numberFormatWithoutSymbol(service_fee, false)}</p>
                              </div>
                            </div>
                            <div className="flex gap-x-4 flex-grow">
                              <div className='w-1/2 flex justify-end'>
                                <p className="text-sm font-bold text-gray-800">BIAYA ADMIN</p>
                              </div>
                              <div className='w-1/2 flex justify-end'>
                                <p className="text-sm font-bold text-gray-800">Belum Termasuk</p>
                              </div>
                            </div>
                            <div className="flex gap-x-4 flex-grow">
                              <div className='w-1/2 flex justify-end'>
                                <p className="text-sm font-bold text-gray-800">TOTAL BAYAR</p>
                              </div>
                              <div className='w-1/2 flex justify-end'>
                                <p className="text-sm font-bold text-gray-800">Rp.&nbsp;</p>
                                {/* <div className="flex-grow" /> */}
                                <p className="text-sm font-bold text-gray-800">{numberFormatWithoutSymbol(total, false)}</p>
                              </div>
                            </div>

                          </div>
                        </div>


                      </div>

                      <div className='w-5/12'>
                        <p className='font-semibold text-gray-700 mb-4 mt-2 text-sm'>Input Data Pemesan</p>
                        <div className='gap-y-4 flex flex-col px-4 py-4 border border-[#d8d8d8] rounded-lg'>
                          <input value={contactName} onChange={(e) => { setContactName(e.target.value) }} type='text' className={inputClass + "  "} placeholder='Input Nama Lengkap Pemesan' />
                          <input value={contactNumber} onChange={(e) => { setContactNumber(e.target.value) }} type='text' className={inputClass + "  "} placeholder='Input Nomor Telepon' />
                          <input value={contactEmail} onChange={(e) => { setContactEmail(e.target.value) }} type='text' className={inputClass + "  "} placeholder='Input Alamat Email' />

                        </div>
                      </div>

                    </div>


                    <div className='mt-2' >
                      <p className='text-md font-semibold mb-4'>Tambah Add On</p>

                      <div className='grid md:grid-cols-2 md:border md:border-gray-200 md:rounded-lg overflow-hidden'>

                        {addons.filter(item => {
                          const isHaveSchedule = item.add_on_item_schedules.length > 0;
                          const hasMatchingSchedule = item.add_on_item_schedules.filter(schedule =>
                            schedule.date_available === props.venueDetail.dateAvailable
                          );
                          const scheduleHours = hasMatchingSchedule.map(schedule => `${schedule.start_time} - ${schedule.end_time}`);
                          const selectedSchedule = props.selectedSchedule.map(schedule => `${schedule.hour}`)
                          const isAvailable = selectedSchedule.length > 0 && selectedSchedule.every(item => scheduleHours.includes(item));
                          return !isHaveSchedule || isAvailable
                        }).map((addon, index) => (
                          <div key={addon.id} className='flex p-2 items-start border border-gray-200'>
                            <img src={process.env.REACT_APP_BASE_URL_IMAGE + addon.image.thumb.url}
                              alt={`icon ${addon.name}`} className='w-[25%] max-w-20 m-2 mr-4' />
                            <div className='flex-grow flex flex-col m-2' >
                              <p className='font-semibold mb-1 text-sm'>{addon.name}</p>
                              <p className='font-semibold mb-4 text-sm'>Rp. {numberFormatWithoutSymbol(addon.price)} / {addon.unit}</p>
                              <span className='flex flex-wrap gap-2 items-center'>
                                <NumberWithButtons onChange={value => {
                                  addons.forEach((item, index) => {
                                    if (item.id === addon.id) {
                                      addons[index].qty = value
                                    }
                                  })
                                  // addons[index].qty = value
                                  console.log(addons)
                                  setAddons(addons)
                                  updatePrice()
                                  updatePromoPrice()

                                }} />
                                {addon.unit === "Hour" && (
                                  <div className="font-semibold text-sm self-center">x Hour</div>
                                )}
                              </span>
                              <p className="font-semibold mt-4 text-sm">{addon.note}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div className="flex gap-x-6 mt-4 font-nunito">
                    <button
                      type="button"
                      className="cursor-pointer inline-flex justify-center rounded-lg bg-primaryRed px-12 py-4 text-sm font-semibold text-white "
                      onClick={prepareBooking}
                    >
                      Booking Jadwal
                    </button>

                    <button
                      type="button"
                      className="cursor-pointer inline-flex justify-center rounded-lg bg-white border border-primaryRed px-12 py-4 text-sm font-semibold text-primaryRed "
                      onClick={props.closeModal}
                    >
                      Batalkan
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  )
}

export default BookingConfirmationDialog;